import { AuthGuard } from '@nsd/fe';
import React, { lazy } from 'react';
import { Search as SearchIcon } from 'react-feather';
import appIcon from './images/appIcon.png';
import TopBarAddOn from 'src/components/TopBarAddOn';
import DashboardLayout from 'src/layouts/DashboardLayout';

const appConfig = {
  //DEV appId: 'documents-10dea2dc-bb56-4487-83cb-a1385bbc8f88',
  appId: 'documents-5c263b6a-d9eb-457b-b073-79fa8b645980',
  appName: 'Documents',
  titleKey: 'documents',
  path: 'documents',
  icon: appIcon,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: 'search',
      view: lazy(() => import('src/views/documents/DocumentSearchView'))
    },
    {
      exact: true,
      path: 'documents',
      redirect: 'search'
    }
  ],
  topBarConfig: {
    dataContextOptions: {
      enableDataContextOverride: true,
      customJSX: <TopBarAddOn />
    },
    contacts: false,
    search: false,
    notifications: true,
    settings: true
  },
  navConfig: {
    navBarItems: [
      {
        subheader: 'Documents',
        items: [
          {
            title: 'Search',
            icon: SearchIcon,
            href: 'search'
          }
        ]
      }
    ]
  }
};

export default appConfig;
